import React from 'react';
import { IconButton, TableCell, TableRow, Tooltip } from "@mui/material";
import MUIDataTable from 'mui-datatables';
import { Localizacion } from 'lib.front';
import LinkIcon from '@mui/icons-material/Link';

const options = {
    filter: false,
    selectableRows: 'none',
    expandableRowsHeader: false,
    pagination: true,
    elevation: 0,
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 15, 100],
    search: false,
    print: false,
    download: false,
    viewColumns: false,
    fixedHeader: false,
    selectToolbarPlacement: 'none',
    selectableRowsOnClick: false,
    textLabels: Localizacion.muiDataTables.ES,

};

const columns = [
    {
        name: "fechaAbono",
        label: "DNI/RUC",
        options: {
            customBodyRender: (value, tableMeta) => {
                const total = tableMeta.rowData[1];
                return (
                    <span style={{ fontWeight: 'bold' }} >
                        {value} - Total del abono {Number(total).toFixed(2)}
                    </span >
                );
            },
            setCellProps: () => ({
                colSpan: 4,
                style: { textAlign: 'left' }
            })
        }
    },
    {
        name: "totalAbono",
        label: "Total",
        options: {
            display: false,
        }
    },
    {
        name: "cliente", label: "Cliente", options: {
            filter: false, sort: false, setCellProps: () => ({
                style: { display: 'none' }
            })
        }
    },
    {
        name: "documento", label: "Documento", options: {
            filter: false, sort: false, setCellProps: () => ({
                style: { display: 'none' }
            })
        }
    },
    {
        name: "monto", label: "Monto Operación", options: {
            filter: false, sort: false, setCellProps: () => ({
                style: { display: 'none' }
            })
        }
    },
    { name: "monto", label: "Monto Abono", options: { filter: false, sort: false } },
    { name: "comision", label: "Comisión", options: { filter: false, sort: false } },
    { name: "fechaPago", label: "Fecha Emisión CPE", options: { filter: false, sort: false } },
    { name: "fechaCobro", label: "Fecha Cobro", options: { filter: false, sort: false } },
    { name: "tipoPago", label: "Tipo Pago", options: { filter: false, sort: false } },
    { name: "pdf", label: "PFD", options: { filter: false, sort: false } },
];

const ReporteConciliacionTable = ({
    data
}) => {

    const aditionalOptions = {
        expandableRows: true,
        renderExpandableRow: (rowData, rowMeta) => {
            const registro = data[rowMeta.dataIndex];
            return (
                <>
                    {registro && registro.detalles.map((detalle, index) => (
                        <TableRow key={`${registro.idAbono}-${index}`}>

                            <TableCell />

                            <TableCell align="center">{detalle.dniRuc}</TableCell>

                            <TableCell align="center">{detalle.cliente}</TableCell>

                            <TableCell align="center">{detalle.documento}</TableCell>

                            <TableCell align="right">{detalle.montoOperacion}</TableCell>

                            <TableCell align="right">{detalle.montoAbono}</TableCell>

                            <TableCell align="right">{detalle.comision}</TableCell>

                            <TableCell align="center">{detalle.fechaPago}</TableCell>

                            <TableCell align="center">{detalle.fechaCobro}</TableCell>

                            <TableCell align="center">{detalle.tipoPago}</TableCell>

                            <TableCell align="center">
                                <IconButton
                                    size="small"
                                    onClick={() => window.open(detalle.pdf, '_blank')}
                                    disabled={!Boolean(detalle.pdf)}
                                    color='primary'
                                >
                                    <LinkIcon fontSize="small" />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </>
            );
        }
    };

    return (
        <MUIDataTable
            options={{ ...options, ...aditionalOptions }}
            columns={columns}
            data={data}
        />
    );
};
export default ReporteConciliacionTable